import styled from 'styled-components';
import { TickCircleIcon } from '../../Account/components/Icons';
import { Progress } from '../../../contexts/tasks';

const AlertIcon = styled.i.attrs(() => ({ className: 'mi-notification' }))`${({ theme }) => `
  color: ${theme.colours.danger[1]};
  font-size: ${theme.fontSize[7]};
`}`;

export default function TaskStatusIcon({ status, updated }: { status: keyof typeof Progress, updated: boolean }) {
  if (updated) {
    return (
      <AlertIcon />
    );
  }

  switch (status) {
    case 'Approved':
    case 'ApprovedWithException':
      return (
        <TickCircleIcon />
      );
    default: return <></>;
  }
}
